import {SearchItem, SearchResultDto} from "./search-table.dto.res";
import {ContactRelationDto} from "../contact.relation.dto";

export class SearchContactRelationRes extends SearchResultDto {

  public override readonly items: SearchContactRelationItem[] = [];

  constructor(init?: Partial<SearchContactRelationRes>) {
    super(init);
    if (init?.items) {
      this.items = init.items.map((i) => new SearchContactRelationItem(i));
    } else {
      this.items = [];
    }
  }
}

export class SearchContactRelationItem extends ContactRelationDto implements SearchItem {

  public override readonly id!: string;

  constructor(init?: Partial<SearchContactRelationItem>) {
    super(init);
    Object.assign(this, init);
  }
}
